import { render } from "./BlockTaskComplete.vue?vue&type=template&id=546469ab&lang=pug"
import script from "./BlockTaskComplete.vue?vue&type=script&lang=js"
export * from "./BlockTaskComplete.vue?vue&type=script&lang=js"

import "./BlockTaskComplete.vue?vue&type=style&index=0&id=546469ab&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__